export default function(appName) {
  return appName?.toLowerCase().includes('azure')
}
